











import Vue from "vue";
import WordMatrix from "./components/WordMatrix.vue";
import RolePicker from "./components/RolePicker.vue";
import { store, Game, getOrCreateGame, getGame, Player } from "./services";

export default Vue.extend({
  name: "App",
  data() {
    return {
      game: {} as Game,
      player: {} as Player,
      interval: {} as NodeJS.Timeout,
    };
  },
  components: {
    WordMatrix,
    RolePicker,
  },
  methods: {
    updateGame(game: Game, player: Player) {
      this.game = game;
      this.player = player;
      this.interval = setInterval(() => {
        getGame(this.game.gameId).then((g) => (this.game = g));
      }, 1000);
    },
    endGame() {
      clearInterval(this.interval);
    },
  },
  created() {
    this.game = store.game;
  },
});
